import { Copy, Menu, MessageCircle, TrendingUp, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'wouter';

const links = [
  { path: '/', label: '首页' },
  { path: '/about', label: '关于我' },
  { path: '/monitor', label: '实盘中心' },
  { path: '/#services', label: '策略服务' },
  { path: '/tools', label: '交易工具' },
  { path: '/insights', label: '交易观点' },
  { path: '/contact', label: '联系我们' },
];

export function openConsultation() {
  window.dispatchEvent(new CustomEvent('open-consultation'));
}

export default function PublicLayout({ children }: { children: React.ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [consultOpen, setConsultOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [location] = useLocation();

  useEffect(() => {
    const show = () => setConsultOpen(true);
    window.addEventListener('open-consultation', show);
    return () => window.removeEventListener('open-consultation', show);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setConsultOpen(false);
    const hash = window.location.hash.slice(1);
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }
    const timer = window.setTimeout(() => document.getElementById(hash)?.scrollIntoView({ block: 'start' }), 80);
    return () => window.clearTimeout(timer);
  }, [location]);

  useEffect(() => {
    const close = (event: KeyboardEvent) => { if (event.key === 'Escape') { setConsultOpen(false); setMenuOpen(false); } };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);

  const copyWechat = async () => {
    await navigator.clipboard.writeText('JM198360');
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  const active = (path: string) => path === '/' ? location === '/' : !path.includes('#') && location.startsWith(path);

  return <div className="site-shell clone-site">
    <header className="site-header clone-header">
      <div className="header-inner">
        <Link href="/" className="brand" aria-label="Jay.H 黄金交易首页"><TrendingUp /><span>Jay.H <b>黄金交易</b></span></Link>
        <nav className={menuOpen ? 'main-nav open' : 'main-nav'} aria-label="主导航">
          {links.map(({ path, label }) => <Link aria-current={active(path) ? 'page' : undefined} className={active(path) ? 'active' : ''} key={path} href={path} onClick={() => {
            setMenuOpen(false);
            if (path.includes('#') && location === '/') window.setTimeout(() => document.getElementById(path.split('#')[1])?.scrollIntoView({ block: 'start' }), 0);
          }}>{label}</Link>)}
        </nav>
        <button className="clone-menu-button" onClick={() => setMenuOpen((value) => !value)} aria-label={menuOpen ? '关闭导航' : '打开导航'}>{menuOpen ? <X /> : <Menu />}</button>
      </div>
    </header>

    <main>{children}</main>

    <footer className="site-footer clone-footer">
      <div className="footer-brand"><Link href="/" className="brand"><TrendingUp /><span>Jay.H <b>黄金交易</b></span></Link><p>专业黄金交易员，专注日内黄金交易与量化策略开发。持续记录真实账户表现、交易观点与风险边界。</p></div>
      <div><h4>快速导航</h4><div className="footer-links"><Link href="/">首页</Link><Link href="/monitor">实盘中心</Link><Link href="/tools">交易工具</Link><Link href="/insights">交易观点</Link></div></div>
      <div><h4>更多</h4><div className="footer-links"><Link href="/about">关于我</Link><Link href="/contact">联系我们</Link><Link href="/risk">风险声明</Link><Link href="/admin">管理后台</Link></div></div>
      <p className="footer-risk">© 2026 Jay.H 黄金交易. All rights reserved. <span>交易有风险，投资需谨慎。历史业绩不代表未来收益。</span></p>
    </footer>

    {consultOpen && <aside className="clone-consult-card" role="dialog" aria-modal="false" aria-labelledby="consult-title">
      <button className="clone-consult-close" onClick={() => setConsultOpen(false)} aria-label="关闭微信咨询"><X /></button>
      <MessageCircle />
      <p id="consult-title">微信咨询</p>
      <strong>JM198360</strong>
      <button className="clone-copy-button" onClick={copyWechat}><Copy />{copied ? '已复制微信号' : '复制微信号'}</button>
      <small>添加时请注明来意，不会索取 MT4/MT5 主交易密码。</small>
    </aside>}
    <button className="consult-fab clone-consult-fab" onClick={() => setConsultOpen((value) => !value)} aria-label="微信咨询"><MessageCircle /><span>微信咨询</span></button>
  </div>;
}
